import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { AuthProvider } from "@shared/lib/auth";
import { ToastProvider } from "@shared/lib/toast";
import { ThemeProvider } from "@shared/lib/ThemeContext";
import { PWAProvider } from "./lib/usePWA";
import { TextureOverlay } from "@shared/components/TextureOverlay";
import { CenterTransitionOverlay } from "@shared/components/CenterTransitionOverlay";
import { FeedbackButton } from "@shared/components/FeedbackButton";
import { PWAUpdatePrompt } from "./components/PWAUpdatePrompt";
import { MessagingPopup } from "./components/messaging/MessagingPopup";
import { ErrorBoundary } from "@shared/components/ErrorBoundary";
import { App } from "./app/App";
import "./styles.css";

// Detect if running in Electron (file:// protocol or Electron user agent)
const isElectron =
  typeof window !== "undefined" &&
  (window.location.protocol === "file:" ||
    navigator.userAgent.toLowerCase().includes("electron"));

// Use HashRouter for Electron (file:// protocol doesn't work with BrowserRouter)
const Router = isElectron ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <TextureOverlay />
          <CenterTransitionOverlay />
          <Router>
            <ErrorBoundary>
              <App />
              <MessagingPopup />
            </ErrorBoundary>
          </Router>
          <FeedbackButton />
          {/* Only show PWA prompts in browser, not Electron */}
          {!isElectron && (
            <PWAProvider>
              <PWAUpdatePrompt />
            </PWAProvider>
          )}
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);


